import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'

// 定义axios 请求响应
axios.interceptors.request.use(function (config) {
  // console.log('axios request')
  if (config.method === 'post') {
    config.data = {
      ...config.data,
      _t: Date.parse(new Date()) / 1000
    }
  } else if (config.method === 'get') {
    config.params = {
      _t: Date.parse(new Date()) / 1000,
      ...config.params
    }
  }
  return config
},
function (error) {
  return Promise.reject(error)
}
)

// 定义一个axios响应拦截器
axios.interceptors.response.use(function (config) {
  // console.log('axios response')
  return config
},
function (error) {
  return Promise.reject(error)
}
)

// main
Vue.use(VueAxios, axios)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
